<template>
  <div class="center-iframe-wrapper">
    <div v-if="loading" class="center-iframe__loading">
      <img class="center-iframe__loading-img" :src="loadingGif" alt="loading" />
    </div>
    <iframe
      ref="iframe"
      class="center-iframe"
      frameborder="0"
      :src="url"
      @load="loading = false"
    ></iframe>
  </div>
</template>

<script>
import loadingGif from '@/assets/imgs/cosmo_loading.gif'

export default {
  name: 'CenterIframe',
  props: {
    url: { type: String, required: true },
    name: { type: String, default: '' }
  },
  data() {
    return {
      loading: true,
      loadingGif
    }
  },
  watch: {
    url() {
      this.loading = true
    }
  }
}
</script>

<style lang="scss" scoped>
.center-iframe-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
}

.center-iframe__loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

.center-iframe__loading-img {
  width: 282px;
  object-fit: contain;
}

.center-iframe {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
